import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';

Vue.use(VueRouter)

import login from '@/views/login/login.vue' //
import css from '@/views/documentation/css/css.vue' //
import accueil from '@/views/accueil/accueil.vue' //
import dashboard from '@/views/dashboard/dashboard.vue' //
import NotFound from '@/components/NotFound.vue' //
import User from '@/views/user/User.vue' //
import loadedData from '@/views/user/loadedData/loadedData.vue' //
import licence from '@/views/portail/licence/licence.vue' //
import account from '@/views/menuPages/accounting/account/account.vue'
import transactions from '@/views/menuPages/accounting/transactions/transactions.vue'//
import inscription from '@/views/menuPages/accounting/inscription/inscription.vue' //
import exercises from '@/views/menuPages/accounting/exercises/exercises.vue' //
import taxes from '@/views/configurations/taxes/taxes.vue' //
import employees from '@/views/configurations/employees/employees.vue' //
import clients from '@/views/invoicing/clients/clients.vue' //
import invoices from '@/views/invoicing/invoices/invoices.vue' //
import clientAccount from '@/views/menuPages/client/clientAccount/clientAccount.vue'//
import suppliercontact from '@/views/menuPages/supplier/contacts/contact.vue'
import contact from '@/views/menuPages/client/contacts/contact.vue'
import supplier from '@/views/menuPages/supplier/supplier/supplier.vue'
import loading from '@/views/menuPages/loading/loading.vue'
import items from '@/views/menuPages/inventory/items/items.vue'
import category from '@/views/menuPages/inventory/category/category.vue'
import department from '@/views/menuPages/inventory/department/department3.vue'
import invoice from '@/views/menuPages/sales/invoice/invoice.vue'

// - PAGE DEBUG
import debugIndex from '../views/debug/debugIndex.vue' //
//import logEr from '../views/debug/logEr/logEr.vue' //

import auth from '../middleware/auth';
import guest from '../middleware/guest';
//import sessiontimeout from '../middleware/sessiontimeout';
//import log from '../middleware/log';
//import VueJwtDecode from 'vue-jwt-decode'

//import {userService} from '@/services'


const routes = [
    // - PAGE DEBUG - debut
    {
        name: "debugIndex",
        path: '/debugIndex',
        component: debugIndex
    },
    //{
    //    name: "logEr",
    //    path: '/logEr',
    //    component: logEr,
    //},
    // - PAGE DEBUG - fin
    
    {
        name: "accueil",
        path: '/',
        component: accueil,
        meta: {
            middleware: [guest,auth],
        }
    },
    {
        name: "dashboard",
        path: '/dashboard',
        component: dashboard,
        meta: {
            middleware: [auth],
            /*requiresAuth : true*/
        }
    },
    {
        name: "login",
        path: '/login',
        component: login,
        meta: {
            middleware: [guest],
        },
    },
    {
        name: "loading",
        path: '/loading',
        component: loading,
        meta: {
            middleware: [auth],
        },
    },
    //DOCUMENTATIONS
    {
        name: "css",
        path: '/documentation/css',
        component: css,
    },
    {
        name: "user",
        path: '/user',
        component: User,
    },
    {
        name: "loadedData",
        path: '/loadedData',
        component: loadedData,
    },
    {
        name: "licence",
        path: '/portail/licence',
        component: licence,
    },
    {
        name: "account",
        path: '/accounting/account',
        component: account,
    },
    {
        name: "transactions",
        path: '/accounting/transactions',
        component: transactions,
    },
    {
        name: "inscription",
        path: '/accounting/inscription',
        component: inscription,
    },
    {
        name: "exercises",
        path: '/configurations/exercises',
        component: exercises,
    },
    {
        name: "taxes",
        path: '/configurations/taxes',
        component: taxes,
    },
    {
        name: "employees",
        path: '/configurations/employees',
        component: employees,
    },
    {
        name: "clients",
        path: '/client/clients',
        component: clients,
    },
    {
        name: "invoices",
        path: '/invoicing/invoices',
        component: invoices,
    },
    {
        name: "clientAccount",
        path: '/client/clientAccount',
        component: clientAccount,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "client.contacts",
        path: '/client/contacts',
        component: contact,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "supplier.contacts",
        path: '/supplier/contacts',
        component: suppliercontact,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "supplier",
        path: '/supplier/suppliers',
        component: supplier,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "items",
        path: '/inventory/items',
        component: items,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "category",
        path: '/inventory/category',
        component: category,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "department",
        path: '/inventory/department',
        component: department,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "invoice",
        path: '/sales/invoice',
        component: invoice,
        meta: {
            middleware: [auth],
        }
    },
    {
        name: "Four-O-Four",
        path: '*',
        component: NotFound
    }




]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to,from,savedPosition)
    {
        console.log('---- scrollBehavior ----');
        console.log(to,from,savedPosition);
        return {x:0, y:0}
    }
})

router.beforeEach(async(to, from, next) => {
    await store.restored;

    if (to.path === '/profile/photos') {
        if (to.meta.auth) {
            console.log("Autorisation necessaire")
        }
    }
    else
    {
        
        if (to.meta.middleware) {
                const middleware = Array.isArray(to.meta.middleware)
                  ? to.meta.middleware
                  : [to.meta.middleware];
            
                const context = {
                  from,
                  next,
                  router,
                  to,
                };
                const nextMiddleware = nextFactory(context, middleware, 1);
                return middleware[0]({ ...context, next: nextMiddleware });
              }
        return next() 
    }
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
      const subsequentMiddleware = middleware[index];
      // If no subsequent Middleware exists,
      // the default `next()` callback is returned.
      if (!subsequentMiddleware) return context.next;
    
      return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
      };
}

export default router